import { connect } from 'react-redux'
import ContactForm from './ContactForm';
import _ from 'lodash';

import { updateContact } from 'src/legacy/redux/actions/rolodex.jsx'

import { fetchOrganizations, invalidateOrganizations } from 'src/legacy/redux/actions/organizations.jsx';
import { fetchContactList } from 'src/legacy/redux/actions/contactList';

const mapStateToProps = (state, ownProps) => {
  return {
    contacts: state.legacyRootReducer.rolodex.items,
    contact: state.legacyRootReducer.rolodex.contact.item,
    updating: state.legacyRootReducer.rolodex.contact.updating,
    errors: state.legacyRootReducer.rolodex.contact.error,
    organizations: state.legacyRootReducer.organizations.items,
    loading: state.legacyRootReducer.organizations.loading,
    totalRecords: _.get(state, `organizations.pagination.totalRecordsCount`),
    currentPage: _.get(state, `organizations.pagination.currentPage`),
    totalPages: _.get(state, `organizations.pagination.totalPages`)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateContact: (contact) => {
      return dispatch(updateContact(contact));
    },

    fetchOrganizations: (query, page) => {
      return dispatch(fetchOrganizations(query, page))
    },

    invalidateOrganizations: () => {
      return dispatch(invalidateOrganizations());
    },

    fetchContactList: (id) => {
      return dispatch(fetchContactList(id));
    },

  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    getContactForID: (id) => {
      return stateProps.contacts.find(function (contact) {
        return contact.id == id;
      });
    },

    getContactForEmail: (email) => {
      return stateProps.contacts.find(function (contact) {
        return contact.email.toLowerCase() == email.toLowerCase();
      });
    }
  })
}

const ContactFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContactForm)

export default ContactFormContainer;